var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex-column jc-center py-5 px-9 fixed" },
    [
      _c("SaasIcon", {
        attrs: { icon: "svgDiscussionCheckbox", width: "134", height: "105" }
      }),
      _vm._v(" "),
      _c("h2", [
        _vm._v(_vm._s(_vm.$l10n.__("Autorisation de l’ADV obligatoire")))
      ]),
      _vm._v(" "),
      _c("h5", { staticClass: "bold my-2" }, [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$l10n.__(
                "Le montant de la nouvelle offre est inférieur à celui de l’abonnement en cours."
              )
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "fs-3 my-0" }, [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$l10n.__(
                "Avant d’envoyer l’offre au client, assurez-vous que le montant de la nouvelle offre a bien été autorisé par l’administrateur des ventes Sellsy."
              )
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("CompassButton", {
        staticClass: "mt-4 flex-item-left",
        attrs: {
          label: _vm.$t.__("pages.account.upsell.AdvAuthorization.understood"),
          type: "primary"
        },
        on: { click: _vm.closeAdvAlert }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }